import React, { useState } from 'react';

function PopupModal({ isOpen, onClose, apiKey }) {
  const [inputValue, setInputValue] = useState(apiKey);

  if (!isOpen) return null;

  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(50, 50, 50, 1)',
    borderRadius: '5px',
    padding: '20px',
    zIndex: 1000,
    width: '600px',
    height: '200px',
    maxWidth: '90%',
    maxHeight: '90%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    overflow: 'auto'
  };

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 999
  };

  return (
    <>
      <div style={backdropStyle} onClick={() => onClose(null)}></div>
      <div style={modalStyle}>
        <span
          className={"font-semibold text-lg text-center"}
        >
          Please enter youe OpenAI API key for your organization
        </span>
        <br /><br />
        <form onSubmit={(e) => { e.preventDefault(); onClose(inputValue); }} className="flex items-center justify-between">
          <input
            placeholder="OpenAI API Key"
            className="p-2 flex-1 border-0 h-auto rounded-[8px] bg-[#2d293b] text-white font-medium outline-0 placeholder-[#8C8A94]"
            rows={1}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />

          <div
            className="p-2 ml-2 hover:bg-[#2313155e] border border-[#8C8A94] rounded-lg font-semibold text-base cursor-pointer"
            onClick={() => onClose(inputValue)}
          >
            Save
          </div>
        </form>
      </div>
    </>
  );
}

export default PopupModal;
